import langText from "./translations";
const Header = () => {
  const lang = "en";
  return <div>{langText[lang].heading}</div>;
};

export default Header;
